/** Ключи вкладок не переименовывать: на них ведут внешние ссылки */

import { MmTaskType } from '../../types/enums';
import { MmTaskTypeProfile } from './taskTypeProfile';

export type MmTaskDetailTabKey = 'summary' | 'items' | 'results' | 'geo' | 'history';

export const MM_TASK_DETAIL_TAB_ORDER: MmTaskDetailTabKey[] = [
  'summary',
  'items',
  'results',
  'geo',
  'history',
];

export const MM_TASK_DETAIL_DEFAULT_TAB: MmTaskDetailTabKey = 'summary';

export interface MmTaskDetailTab {
  key: MmTaskDetailTabKey;
  labelKey: string;
}

const TAB_LABEL_KEYS: { [key: string]: string } = {
  summary: 'priceMonitoring.mobileMonitoring.taskCard.tabSummary',
  items: 'priceMonitoring.mobileMonitoring.taskCard.tabItems',
  results: 'priceMonitoring.mobileMonitoring.taskCard.tabResults',
  geo: 'priceMonitoring.mobileMonitoring.taskCard.tabGeo',
  history: 'priceMonitoring.mobileMonitoring.taskCard.tabHistory',
};

export function hasPlanTab(taskType: MmTaskType | null): boolean {
  return taskType === MmTaskType.FREE || taskType === MmTaskType.KVI;
}

export function listVisibleTaskDetailTabs(
  taskType: MmTaskType | null,
  profile: MmTaskTypeProfile | null,
): MmTaskDetailTab[] {
  const visible: MmTaskDetailTab[] = [];

  for (let i = 0; i < MM_TASK_DETAIL_TAB_ORDER.length; i += 1) {
    const key = MM_TASK_DETAIL_TAB_ORDER[i];

    if (isTabRendered(key, taskType)) {
      visible.push({ key: key, labelKey: TAB_LABEL_KEYS[key] });
    }
  }

  return visible;
}

export function isTabRendered(key: MmTaskDetailTabKey, taskType: MmTaskType | null): boolean {
  if (key === 'geo' || key === 'history') {
    return false;
  }

  if (key === 'items') {
    return hasPlanTab(taskType);
  }

  return true;
}

export function resolveDefaultTab(taskType: MmTaskType | null): MmTaskDetailTabKey {
  const visible = listVisibleTaskDetailTabs(taskType, null);

  return visible.length > 0 ? visible[0].key : MM_TASK_DETAIL_DEFAULT_TAB;
}

export function normalizeTabKey(raw: string | null, taskType: MmTaskType | null): MmTaskDetailTabKey {
  if (raw === null || raw === undefined || raw === '') {
    return resolveDefaultTab(taskType);
  }

  for (let i = 0; i < MM_TASK_DETAIL_TAB_ORDER.length; i += 1) {
    const key = MM_TASK_DETAIL_TAB_ORDER[i];

    if (key === raw && isTabRendered(key, taskType)) {
      return key;
    }
  }

  return resolveDefaultTab(taskType);
}
